import _ from 'lodash'

import { MaskFieldCompleteResource, Wemi } from "@skinsoft/types"
import { getOnlyValuesFromMaskFields, removeWemiPrefix } from "@skinsoft/utils/mask-fields-utils"
import { cleanRefs, cleanValueToSort } from "@skinsoft/utils/es-types-helper"

import { wemi_metaRecordMask } from '@skinsoft/record-mask-configs'

export function extractCachedWemiChanges(wemiCached: Wemi): Wemi {
    const result: Wemi = {}

    let wemiCachedWithoutPrefix = removeWemiPrefix(wemiCached)
    wemiCachedWithoutPrefix = cleanRefs(wemiCachedWithoutPrefix)
    wemiCachedWithoutPrefix = cleanValueToSort(wemiCachedWithoutPrefix)

    const masks: MaskFieldCompleteResource[] = wemi_metaRecordMask.categories?.flatMap(category => category.maskFields ?? []) ?? []

    const itemMasks = masks.filter(mask => {
        return mask.entityField?.abstractEntity?.toLowerCase().includes("item")
    })

    const manifestationMasks = masks.filter(mask => {
        return mask.entityField?.abstractEntity?.toLowerCase().includes("manifestation")
    })

    const expressionMasks = masks.filter(mask => {
        return mask.entityField?.abstractEntity?.toLowerCase().includes("expression")
    })

    const workMasks = masks.filter(mask => {
        return mask.entityField?.abstractEntity?.toLowerCase().includes("work")
    })


    const itemValues = getOnlyValuesFromMaskFields(
        wemiCachedWithoutPrefix,
        itemMasks,
        //cleanValues
    )
    _.set(
        result,
        "item",
        itemValues
    )

    const manifestationValues = getOnlyValuesFromMaskFields(
        wemiCachedWithoutPrefix,
        manifestationMasks,
        //cleanValues
    )
    _.set(
        result,
        "manifestation",
        manifestationValues
    )

    const expressionValues = getOnlyValuesFromMaskFields(
        wemiCachedWithoutPrefix,
        expressionMasks,
        //cleanValues
    )
    _.set(
        result,
        "expression",
        expressionValues
    )

    const workValues = getOnlyValuesFromMaskFields(
        wemiCachedWithoutPrefix,
        workMasks,
        //cleanValues
    )
    _.set(
        result,
        "work",
        workValues
    )

    // prevents to change inventory number offline
    _.unset(
        result,
        "item.identificationItemSchema.identifiers.0.identifier"
    )
    if(result.item?.identificationItemSchema?.identifiers === null || 
        (result.item?.identificationItemSchema?.identifiers && result.item.identificationItemSchema.identifiers.length === 0)
    ) {
        _.unset(
            result,
            "item.identificationItemSchema.identifiers"
        )
    }

    if(wemiCached.item?.associatedMedias) {
        _.set(
            result,
            "item.associatedMedias",
            wemiCached.item?.associatedMedias
        )
    }

    return result
}